import { useMemo } from 'react';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import BackToTop from '@/components/feature/BackToTop';
import { useSeo } from '@/hooks/useSeo';
import HeroSection from './components/HeroSection';
import HotRankSection from './components/HotRankSection';
import PlaySection from './components/PlaySection';
import FeaturedTopics from './components/FeaturedTopics';
import BrandVoiceSection from './components/BrandVoiceSection';
import HomeFaqSection from './components/HomeFaqSection';

export default function Home() {
  const jsonLd = useMemo(
    () => [
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: '瓜田福利社',
        description: '聚合娱乐热点话题并提供转发抽奖、评论区打卡、粉丝投票玩法的内容互动社区。',
        email: 'hello@guatianfuli.com',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: '瓜田福利社',
        inLanguage: 'zh-CN',
        potentialAction: {
          '@type': 'SearchAction',
          target: '/topics?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
    ],
    [],
  );

  useSeo({
    title: '瓜田福利社 - 福利吃瓜转发抽奖 评论区打卡 粉丝投票玩法全解锁',
    description:
      '瓜田福利社专注福利吃瓜，聚合娱乐热点话题，解锁福利吃瓜转发、抽奖、评论区互动、打卡、粉丝投票等玩法。边吃瓜边互动，赢取专属福利，和同好一起玩转评论区。',
    keywords: '福利吃瓜,福利吃瓜转发,福利吃瓜抽奖,福利吃瓜评论区,福利吃瓜打卡,福利吃瓜粉丝投票',
    path: '/',
    jsonLd,
  });

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader transparentOnTop />
      <main>
        <HeroSection />
        <HotRankSection />
        <PlaySection />
        <FeaturedTopics />
        <BrandVoiceSection />
        <HomeFaqSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}